require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./ivca-impact-and-sustainable-investment-conference.json") })
        }
      }, "path---ivca-impact-and-sustainable-investment-conference");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---ivca-impact-and-sustainable-investment-conference!./.cache/json/ivca-impact-and-sustainable-investment-conference.json
// module id = 1164
// module chunks = 231608221292675